<template>
    <v-card class="my-5" :loading="loading">
        <v-card-title>Producten (Prijs op basis van {{ adults }} volwassenen)</v-card-title>
        <v-card-text>

            <b-alert color="warning" v-if="!this.validDates">
                Vertrek en/of boekingdatum niet correct ingevuld.
            </b-alert>

            <v-simple-table v-if="this.validDates">
                <template v-slot:default>
                    <thead>
                    <tr>
                        <th>Product</th>
                        <th>Type</th>
                        <th>code</th>
                        <th>Prijs Per Persoon</th>
                        <th>Prijs Totaal</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="productLine of packageObj.activeLines" :key="productLine.id">
                        <template v-if="productLine.product.activeVersion">
                            <td>{{
                                    productLine.product.activeVersion.name ? productLine.product.activeVersion.name : 'Vlucht: ' + productLine.product.activeVersion.flight.departureAirport.label + ' - ' + productLine.product.activeVersion.flight.arrivalAirport.label
                                }}
                            </td>
                            <td>{{ productLine.product.activeVersion.type.name }}</td>
                            <td>{{ productLine.product.activeVersion.code }}</td>
                            <td>
                                {{ (getPriceByProductId(productLine.product.active_version_id) / adults) |formattedPrice }}
                                (p.p.)
                            </td>
                            <td>{{ getPriceByProductId(productLine.product.active_version_id) |formattedPrice }}</td>
                        </template>
                        <template v-else>
                            <td class="red--text">Let op! Er is een inactief product gevonden</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </template>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <td colspan="3"
                            class="text-end"><strong>Totaalprijs</strong></td>
                        <td>{{ (TotalPrice / adults) |formattedPrice }} (p.p.)</td>
                        <td>{{ TotalPrice |formattedPrice }}</td>
                    </tr>
                    </tfoot>
                </template>
            </v-simple-table>
        </v-card-text>
    </v-card>
</template>

<script>
import Package from "@/models/Package/Package";
import moment from "moment";
import BAlert from "@/components/General/Alert/BAlert";

export default {
    name: "PackageProductsInfo",
    components: {BAlert},
    props: {
        adults: {
            type: Number,
            required: true
        },
        bookDate: {
            type: String,
            required: true,
            default:'',
        },
        departureDate: {
            type: String,
            required: true,
            default:'',
        },
        packageObj: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            loading: false,
            products: [],
        }
    },
    watch:{
        bookDate(){
            this.fetchPackageDetailPrices();
        },
        departureDate(){
            this.fetchPackageDetailPrices();
        },
        adults(){
            this.fetchPackageDetailPrices();
        }
    },
    computed: {
        TotalPrice() {
            let total = 0;

            this.products.forEach(function (product) {
                total += product.options.cheapest.totalSalePrice;
            });
            return total;
        },
        validDates() {
            return (
                this.bookDate && this.departureDate &&
                moment(this.bookDate).isValid() && moment(this.departureDate).isValid()
            )
        }
    },
    methods: {
        fetchPackageDetailPrices() {
            if (this.validDates) {
                this.loading = true;

                return Package.api()
                    .action(this.packageObj.id + '/products/options')
                    .where('book_date', this.bookDate)
                    .where('adults', this.adults)
                    .where('children', 0)
                    .where('start_date', this.departureDate)
                    .get().then((products) => {
                        this.products = products;
                        this.loading = false;
                    })
            }
        },
        getPriceByProductId(activeVersionId) {
            let product = this.products.find(price => price.active_version_id === activeVersionId);
            if (product) {
                return product.options.cheapest.totalSalePrice;
            }
            return 0;
        }
    },
    mounted() {
        this.fetchPackageDetailPrices();

    }
}
</script>

